// extracted by mini-css-extract-plugin
export default {"container":"bra_TrzKa","inner":"bra_inn_1pSzb","thumbnail":"bra_thu_1mxfY","picture":"bra_pic_3zljY","label":"bra_lab_Righw","name":"bra_nam_1T--3","description":"bra_des_1PpfC"};